/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Copy_Success_PersonalInputs */



/**
* | output |
* | --- |
* | "Created your own copy in your personal project" |
*
* @param {Artifact_Copy_Success_PersonalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_copy_success_personal = /** @type {((inputs?: Artifact_Copy_Success_PersonalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Copy_Success_PersonalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigene Kopie in Ihrem persönlichen Projekt erstellt")
	return /** @type {LocalizedString} */ ("Created your own copy in your personal project")
});